import { Link } from "react-router-dom";
import { ClipboardList } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { useOfflineData } from "@/contexts/OfflineDataContext";

export default function ProceduresPage() {
  const { procedures } = useOfflineData();

  return (
    <div className="space-y-6">
      <div>
        <h1 className="font-heading text-2xl font-bold flex items-center gap-2">
          <ClipboardList className="w-6 h-6" />
          Procedures
        </h1>
        <p className="text-muted-foreground">{procedures.length} procedures available</p>
      </div>

      <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
        {procedures.map(procedure => (
          <Link key={procedure.id} to={`/procedure/${procedure.id}`}>
            <Card className="h-full hover:border-primary/50 transition-colors cursor-pointer">
              <CardHeader>
                <CardTitle className="text-lg font-heading">{procedure.name}</CardTitle>
                {procedure.care_level && (
                  <Badge variant="outline">{procedure.care_level.toUpperCase()}</Badge>
                )}
              </CardHeader>
              <CardContent>
                <p className="text-sm text-muted-foreground line-clamp-3">
                  {procedure.steps?.[0]?.text || "Clinical procedure"}
                </p>
              </CardContent>
            </Card>
          </Link>
        ))}
      </div>
    </div>
  );
}
